import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils.js";

function AssignPatientModal(props) {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(props.patients)) {
      const newOptions = props.patients.map((patient) => ({
        value: patient.id,
        label: patient.name,
      }));
      setOptions(newOptions);
    }
  }, [props.patients]);

  const handleSubmit = (event) => {
    let url_appendix = "set_program_for_multiple_patients";
    if (props.template === true) {
      url_appendix = "set_template_as_program_for_multiple_patients";
    }
    let param_arr = [];
    if (selectedOptions && selectedOptions.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      const url =
        process.env.REACT_APP_SOPHYAPP_API_URL +
        "/de/react/" +
        getAccessToken() +
        "/program/" +
        url_appendix;
      var params = new FormData();
      params.append("program_id", props.program);
      selectedOptions.map((patient) => param_arr.push(patient.value));
      params.append("patients", JSON.stringify(param_arr));
      params.append("template", props.template);
      axios
        .post(url, params)
        .then(function () {
          if (props.setAssignedSuccess) {
            props.setAssignedSuccess(true);
          }
        })
        .catch(function () {
          if (props.setAssignedFailed) {
            props.setAssignedFailed(true);
          }
        });
      props.onHide();
    } else {
      props.onHide();
      event.preventDefault();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("general.assignProgram")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Control value={1} type="hidden" name="id" />
            </Form.Group>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("patients.list")}</Form.Label>
            <Select
              isMulti
              name="patients"
              defaultValue={selectedOptions}
              options={options}
              className="basic-multi-select"
              classNamePrefix="select"
              required
              onChange={setSelectedOptions}
              freeSolo
              createOption={() => {}}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("profile.save")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AssignPatientModal;
